import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const BizumIcon = (props: SvgIconProps) => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 38.1 50" {...props}>
    <path
      fill="#05c0c7"
      fillRule="evenodd"
      d="M9.2 17.9c1.8 1.3 4.4.9 5.7-.9l4.8-6.6c1.3-1.8.9-4.4-.9-5.7s-4.4-.9-5.7.9l-4.8 6.6c-1.3 1.8-.9 4.3.9 5.7M31 8.6c-1.8-1.3-4.4-.9-5.7.9L6.1 35.8c-1.3 1.8-.9 4.4.9 5.7s4.4.9 5.7-.9l19.1-26.3c1.4-1.8 1-4.4-.8-5.7M7.4 6.5c1.3-1.8.9-4.4-.9-5.7s-4.4-1-5.7.9c-1.3 1.8-1 4.3.9 5.7 1.8 1.3 4.3.9 5.7-.9m29 36.1c-1.8-1.3-4.4-.9-5.7.9s-.9 4.4.9 5.7 4.4.9 5.7-.9.9-4.3-.9-5.7m-7.5-10.4c-1.8-1.3-4.4-.9-5.7.9l-4.8 6.6c-1.3 1.8-.9 4.4.9 5.7s4.4.9 5.7-.9l4.8-6.6c1.3-1.8.9-4.4-.9-5.7"
      clipRule="evenodd"
    ></path>
  </SvgIcon>
)

export default BizumIcon
